// extracted by mini-css-extract-plugin
export default {"section3":"Section3_section3__x1cvZ"};